













































































































































































































































































































































































































































































































































































































import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import draggable from "vuedraggable";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import ConfirmationDialog from "@/components/common/ConfirmationDialog.vue";
import SimpleMenuTextEditor from "@/components/common/SimpleMenuTextEditor.vue";
import ScoringKeyEditorDialog from "@/components/scoring-key/ScoringKeyEditorDialog.vue";
import ScoringKeys from "@/store/modules/ScoringKeys";
import FactorScoringDefinitionCreatorDialog from "@/components/scoring-definition/FactorScoringDefinitionCreatorDialog.vue";
import { mixins } from "vue-class-component";
import ElementSelect from "@/components/mixins/ElementSelect";
import SimpleMenuDescriptionEditor from "@/components/common/SimpleMenuDescriptionEditor.vue";
import Dialogs from "@/store/modules/Dialogs";
import ModelScoringKeyButtonTrigger from "@/components/scoring-key/ModelScoringKeyButtonTrigger.vue";
import ModelFactorScoringDefinitionButtonTrigger from "@/components/scoring-definition/ModelFactorScoringDefinitionButtonTrigger.vue";
import ValueTypes from "@/utils/ValueTypes";
import Decisions from "@/store/modules/Decisions";
import Modelling from "@/store/modules/Modelling";
import { Factor, FactorGroup, FactorResource } from "@/api/model/FactorResource";
import ModelFixedTableBuilder from "@/views/ModelBuilder/ModelFixedTableBuilder.vue";
import ModelGrowingTableBuilder from "@/views/ModelBuilder/ModelGrowingTableBuilder.vue";
import AdditionalCommandsMenu from "@/views/ModelBuilder/AdditionalCommandsMenu.vue";
import AddResourceButton from "@/views/ModelBuilder/AddResourceButton.vue";
import FactorGroupScoringDefinition from "@/components/scoring-definition/FactorGroupScoringDefinition.vue";
import HeadingDescriptionEditor from "@/components/common/HeadingDescriptionEditor.vue";
import CommentBadge from '@/components/comments/CommentBadge.vue';
import _ from "lodash";
import HistogramChart from '@/components/chart/HistogramChart.vue';
import BarChart from '@/components/chart/BarChart.vue';

const decisionsModule = getModule(Decisions);
const modellingModule = getModule(Modelling);
const scoringKeysModule = getModule(ScoringKeys);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const dialogsModule = getModule(Dialogs);

@Component({
    name: "ModelBuilderRecursiveGroupComp",
    components: {
        ModelGrowingTableBuilder,
        ModelFixedTableBuilder,
        ButtonModelScoringDefinitionTrigger: ModelFactorScoringDefinitionButtonTrigger,
        ButtonModelScoringKeyTrigger: ModelScoringKeyButtonTrigger,
        SimpleMenuDescriptionEditor,
        AdditionalCommandsMenu,
        DialogFactorScoringDefinitionCreator: FactorScoringDefinitionCreatorDialog,
        ScoringKeyEditorDialog,
        AddResourceButton,
        SimpleMenuTextEditor,
        ConfirmationDialog,
        draggable,
        FactorGroupScoringDefinition,
        HeadingDescriptionEditor,
        CommentBadge,
        HistogramChart,
        BarChart
    },
})
export default class ModelBuilderRecursiveGroup extends mixins(ElementSelect) {
    private readonly VALUE_TYPES = ValueTypes.VALUE_TYPES;

    @Prop()
    parentId!: string;

    @Prop()
    elements!: string[];

    @Prop()
    activeWorkingResourceParent!: string;

    @Prop({default: false, type: Boolean})
    sandbox!: boolean

    private processing = false;
    private activeWorkingResource: string = "";
    private activeEditingResource: string = "";
    private iconList: any = {
        NONE: "mdi-border-none-variant",
        TEXT: "mdi-format-text",
        FILE: "mdi-file-outline",
        IMAGE: "mdi-camera",
        NUMERICAL: "mdi-pound",
        DATE_TIME: "mdi-calendar-clock",
        PRICE: "mdi-currency-usd",
        PERCENTAGE: "mdi-percent",
        CATEGORICAL: "mdi-tag",
        BOOLEAN: "mdi-checkbox-marked",
    };

    get mbDraggable() {
        return workspaceOptionsModule.mbDraggable;
    }

    // description
    get descriptionVisibility() {
        return workspaceOptionsModule.descriptionVisibility;
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get factorResources() {
        if(this.sandbox) {
            return modellingModule.workingModelFactorResources;
        }
        return modellingModule.publishedModelFactorResources;
    }

    get expansionValues() {
        return workspaceOptionsModule.draftExpansions;
    }

    get selectionPath() {
        return workspaceOptionsModule.draftSelectionPath;
    }

    get selectedCopyElement() {
        return modellingModule.copyFactorResource;
    }

    get editModel() {
        return workspaceOptionsModule.editModel;
    }

    get editSumRule() {
        return workspaceOptionsModule.editSumRule;
    }

    get editScoringRule() {
        return workspaceOptionsModule.editScoringRule;
    }

    get editComments() {
        return workspaceOptionsModule.editComments;
    }

    private open(resourceId:string) {
        Vue.set(this.expansionValues,resourceId,0);
        // this.expansionValues[resourceId] = 0;
        // this.expansionValues[resourceId].push(0);
    }

    private close(resourceId:string) {
        Vue.set(this.expansionValues,resourceId,undefined);
    }

    // get left nav icons
    private getIcon(id: string) {
        if (!id || !this.factorResources.hasOwnProperty(id)) return;
        let factor = this.factorResources[id] as Factor;
        if (factor.valueTypeDefinition && factor.valueTypeDefinition.valueSubType) {
            return this.iconList[factor.valueTypeDefinition.valueSubType];
        } else if (factor.valueTypeDefinition) {
            return this.iconList[factor.valueTypeDefinition.valueType];
        }
        return this.iconList["NONE"];
    }

    private getFactorValueType(factorId: string) {
        let factor = this.factorResources[factorId] as Factor;
        return this.VALUE_TYPES.find(
            (v) =>
                factor.valueTypeDefinition &&
                v.valueType == factor.valueTypeDefinition.valueType &&
                v.valueSubType == factor.valueTypeDefinition.valueSubType
        );
    }

    @Watch("activeWorkingResourceParent")
    onParentWorkingResource(newVal: string) {
        this.activeEditingResource = newVal;
    }

    private getDescriptionVisibility() {
        return this.descriptionVisibility;
    }

    private updateFactorDescription(factorId: string, description: string) {
        let factor = this.factorResources[factorId];
        if (factor.description === description) return;
        factor.description = description;
        this.updateFactor(factor);
    }

    private updateFactorName(factorId: string, name: string) {
        let factor = this.factorResources[factorId];
        if (factor.name === name) return;
        factor.name = name;
        this.updateFactor(factor);
    }
    // pencil popup dialog
    private updateFactorNameAndDescription(factorId: string, obj: any) {
        let factor = this.factorResources[factorId];
        if (factor.name === obj.name && factor.description === obj.description) return;
        factor.name = obj.name;
        factor.description = obj.description;
        this.updateFactor(factor);
    }

    private async updateFactor(factor: any) {
        await modellingModule.updateFactorResource(factor);
    }

    private async factorMoved(event: any, factor: any) {
        await modellingModule.updateFactorResource(factor);
    }

    private async closeGroup(e: any) {
        if (!e) return;
        let factor = this.factorResources[e.item._underlying_vm_];
        if (factor && factor.type === "FACTOR_GROUP") {
            this.expansionValues[factor.id] = undefined;
        }
    }

    private async createFactor(groupElement?: FactorResource, convertFactor?: boolean) {
        let parentGroupElementId = groupElement ? groupElement.id : "M";
        if (convertFactor && groupElement) {
            let convertedFactor = await this.convertFactorToGroup(groupElement as Factor);
            parentGroupElementId = convertedFactor.id;
        }
        if (groupElement) {
            await dialogsModule.createFactor({
                parentId: parentGroupElementId
            });
            return;
        }
    }
    
    private async editFactorResource(resourceId: string, parentId: string) {
        await dialogsModule.createFactor({
            parentId: parentId,
            factorResourceId: resourceId,
        });
    }

    private async convertFactorToGroup(factor: Factor) {
        //@ts-ignore
        let factorResource: FactorGroup = {
            id: factor.id,
            name: factor.name,
            description: factor.description,
            type: "FACTOR_GROUP",
            summaryScoringFunction: "WEIGHTED_SUM",
            childrenIds: [],
        };
        return await modellingModule.updateFactorResource(factorResource);
    }

    private copyElement(factorResource: FactorResource) {
        modellingModule.copySubTree(factorResource);
    }

    @Emit('paste')
    private paste(payload: { destinationId: string; destinationIndex?: number }) {
        return payload;
    }

    private decisionPaste (payload: any) {
        this.$emit('decision-paste', payload)
    }

    @Emit("resource-deleted")
    private async deleteResource(resourceId: string) {
        await modellingModule.deleteFactorResource(resourceId);
    }

    // submit summary scoring function to database
    // @param resourceId - resourceId from v-for of elements
    // @param scoringDefinition - summaryScoringFunction choice from child dialog form
    private async submitFactorScoringSum(resourceId, scoringDefinition) {
        if (this.factorResources[resourceId]) {
            this.factorResources[resourceId]['hideScores'] = scoringDefinition.hideScores;
            this.factorResources[resourceId].summaryScoringFunction =
                scoringDefinition.summaryScoringFunction;
            await modellingModule.updateFactorResource(this.factorResources[resourceId]);
        }
    }

    private async createFromList(payload: any, resourceId: string) {
        let id = _.cloneDeep(resourceId)
        let list = payload.names;
        let type = payload.type;
        if (list.length) {
            if(type != 'Factor Group') {
                let factors = list.filter(l => l)
                    .map(name => {
                        if(type === 'DATE_TIME') {
                            return {
                                name: name,
                                type: 'FACTOR',
                                modelId: decisionsModule.selectedDecisionId,
                                numWeightingDots: 1,
                                valueTypeDefinition: {valueType: type ? type: 'NONE', format: "YYYY-MM-DD"}
                            } as Factor
                        } else if (type === 'TEXT') {
                            return {
                                name: name,
                                type: 'FACTOR',
                                modelId: decisionsModule.selectedDecisionId,
                                numWeightingDots: 1,
                                valueTypeDefinition: {valueType: type ? type: 'NONE', format: "HTML"}
                            } as Factor
                        } else {
                             return {
                                name: name,
                                type: 'FACTOR',
                                modelId: decisionsModule.selectedDecisionId,
                                numWeightingDots: 1,
                                valueTypeDefinition: {valueType: type ? type: 'NONE'}
                            } as Factor
                        }
                    })
                await modellingModule.createFactorsFromList({factors: factors, destinationFactorResourceId: id})          
            } else {
                let factors = list.filter(l => l)
                    .map(name => {
                        return {
                            name: name,
                            type: 'FACTOR_GROUP',
                            modelId: decisionsModule.selectedDecisionId,
                            childrenIds: [],
                            summaryScoringFunction: "WEIGHTED_SUM",
                            hideScores: false
                        } as FactorGroup
                    })
                await modellingModule.createFactorsFromList({factors: factors, destinationFactorResourceId: id})       
            }
              
        }
    }
}
